import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';

const PrivateRoute = ({ element, roles }) => {
  const admin = secureLocalStorage.getItem('admin-info');
  if (!admin?.role) {
    return <Navigate to="/" replace />;
  }
  if (roles && roles?.includes(admin?.role)) {
    return <Outlet />;
  }
  if (roles && !roles?.includes(admin?.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return element;
};

export default PrivateRoute;
